module.exports = __webpack_public_path__ + "models/scene5.1943b6d.atlas";